// This file is autogenerated by scripts/insertPolyfills.mts
// Do not edit it manually

import 'core-js/modules/es.promise.all-settled';
import 'core-js/modules/es.promise.finally';

window.global = window;
